import styled, { keyframes } from 'styled-components/macro'

import { Button, Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

const animation = keyframes`
  0% {
    max-height: 0;
    opacity: 0;
  }

  25% {
    max-height: 100px;
  }

  98% {
    max-height: 100%;
    opacity: 1;
  }
`

export const StyledText = styled(Text)`
  ${screen.sm} {
    max-width: 352px;
  }
`

export const Banner = styled.div`
  border: 1px solid ${getToken('color-neutral-light')};
  border-radius: ${getToken('border-radius-s')};
  transform: translateZ(0);
  animation: ${animation} 600ms ease-in-out;
  background-color: ${getToken('color-neutral-white')};
`

export const StyledLayoutStack = styled(Layout.Stack)`
  padding: ${getToken('space-xl')};
`

export const BannerButton = styled(Button)`
  width: fit-content;
`

export const ImageBanner = styled.img`
  border-radius: ${getToken('border-radius-s')};
  width: 100%;
  margin-left: 0;
  object-fit: cover;

  ${screen.md} {
    width: 50%;
    margin-left: auto;
    border-left: 1px solid ${getToken('color-neutral-light')};
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`
